import { defineStore } from "pinia";
import { ref } from "vue";

export const useMessageStore = defineStore('message', () => {
  const messages = ref<any[]>([])

  function add(text: string) {
    messages.value.push({ text })
  }

  function addSuccess(text: string) {
    messages.value.push({ text, color: 'success' })
  }

  function addError(text: string = 'Der skete desværre en fejl. Prøv venligst igen senere.') {
    messages.value.push({ text, color: 'error' })
  }

  return { messages, add, addSuccess, addError }
})